/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 19:59:48
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-11 14:06:24
 * @name: cookie数据
 * @Description: cookie数据
 * @FilePath: \preSaleNafterSaleInside\project\src\storage\cookie.js
 * @Author: DESKTOP-1QU67QM
 */
import Cookies from 'js-cookie';

const cookie = class {
    constructor() {
        this.cookie_title = 'preSaleNafterSaleInside_';
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取cookie
     * @param {String} key 获取数据键
     */    
    get(key) {
        return Cookies.get(`${this.cookie_title}${key}`);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 设置cookie
     * @param {String} key 设置数据键
     * @param {Any} value 设置数据值
     */  
    set(key,value) {
        return Cookies.set(`${this.cookie_title}${key}`,value);
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 移除cookie
     * @param {String} key 移除数据键
     */  
    remove(key) {
        return Cookies.remove(`${this.cookie_title}${key}`);
    }
}

export default cookie;